import querystring from 'querystring'
import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/data/geo/pointsOfInterest`

export default {
  getGlobalPointsOfInterest(bounds, poiType) {
    const southWestLat = bounds.getSouthWest().lat()
    const southWestLng = bounds.getSouthWest().lng()
    const northEastLat = bounds.getNorthEast().lat()
    const northEastLng = bounds.getNorthEast().lng()
    const params = {
      southWestLat,
      southWestLng,
      northEastLat,
      northEastLng,
      poiType,
    }
    return ApiService.get(`${resourceUrl}/globalPins?${querystring.stringify(params)}`)
  },
  getPointsOfInterest(parentAttribute, parentId) {
    const params = {
      parentAttribute,
      parentId,
    }
    return ApiService.get(`${resourceUrl}/pins?${querystring.stringify(params)}`)
  },
  getPointsOfInterestTypes() {
    return ApiService.get(`${resourceUrl}/poiTypes`)
  },
  linkGlobalPOI(id, parentAttribute, parentId) {
    return ApiService.put(
      `${resourceUrl}/linkGlobalPOI?id=${id}&parentAttribute=${parentAttribute}&parentId=${parentId}`,
    )
  },
}
